$(document).ready(function () {
  if ($("#tb-store-product .product__description").length && $(".featured-product").length) {
    $("#tb-store-product .product__description").appendTo(".featured-product");
  }
});
$(document).ready(function () {
  if ($("#product-page .product__description").length && $("#product-page").length) {
    $("#product-page .product__description").appendTo("#product-page");
  }
});
// ========================== Add Common-Home Class On Body Tag ==========================
document.addEventListener('DOMContentLoaded', function() {
var slideshowElement = document.getElementById('tb-slideshow');
if (slideshowElement) {
  document.body.classList.add('common-home');
}
});


// ========================== BACK TO TOP ========================== 
$(window).scroll(function () {
  if ($(this).scrollTop() >= 50) {
    $('#return-to-top').fadeIn(200);
  } else {
    $('#return-to-top').fadeOut(200);
  }
});
$('#return-to-top').click(function () {
  $('body,html').animate({
    scrollTop: 0
  }, 500);
});


// ========================== MENU-CLICK HIDE MENU DROPDOWN ==========================
$(document).ready(function() {
  $('.list-menu__item').on('click', function() {
    $('#Details-menu-drawer-container').removeAttr('open');
    $('.header__icon').attr('aria-expanded', 'false');
    $('body').removeClass('overflow-hidden-tablet');
    $('.menu-opening').removeClass('menu-opening');
  });
});


// ========================== CUSTOMERS OWL-CAROUSEL ==========================
var tb_customer = $(document).ready(function(){
  $('#tb-customers .tb-customer-wrapper').owlCarousel({
      items : 4,
      margin: 30,
      nav: false,
      dots: true,
      loop: false,
      responsive: {
              0: {
                 items:1
              },
              576:{
                  items:2
              },
              992:{
                  items:3
              },
              1200:{
                  items:4    
              }
          }
  });
});


// ========================== RELATED PRODUCT OWL-CAROUSEL ==========================
var tb_related_product = $(document).ready(function(){
  $('#productThumbs').owlCarousel({
      items : 4,
      margin: 15,
      nav: true,
      dots: false,
      loop: false,
      responsive: {
              0:{
                  items:2
              },
              481:{
                  items:3
              },
              576:{
                  items:4
              },
              768:{
                  items:5
              },
              992:{
                  items:3
              },
              1300:{
                  items:4  
              }
          }
  });
});


// ========================== FOOTER TOGGLE ==========================
function footerToggle() {
    if ($(window).width() < 992) {
        $(".tb-footer-center .footer-column h5").addClass("toggle");
        $(".tb-footer-center .footer-column h5.toggle").unbind("click");
        var Accordions = function (el, multiple) {
            this.el = el || {};
            this.multiple = multiple || false;
            var link = this.el.find('.toggle');
            link.on('click', { el: this.el, multiple: this.multiple }, this.dropdown)
        }
        Accordions.prototype.dropdown = function (e) {
            var $el = e.data.el;
            $this = $(this),
                $next = $this.next();
            $next.slideToggle();
            $this.parent().toggleClass('active');
            if (!e.data.multiple) {
                $el.find('.tb-footer-center .footer-column').not($next).slideUp().parent().removeClass('active');
            };
        }
        var accordions = new Accordions($('.tb-footer-center .footer-column'), false);
    } else {
        $(".tb-footer-center .footer-column h5.toggle").unbind("click");
        $(".tb-footer-center .footer-column h5").removeClass('toggle');
    }
}
$(document).ready(function () { footerToggle(); });
$(window).resize(function () { footerToggle(); });



// ========================== RELATED PRODUCT ==========================
$(document).ready(function() {
  // Add active class to the first image by default
  $('.tb-related-product:first').parent().addClass('active');

  // Attach click event listener to each related product thumbnail
  $('.tb-related-product').click(function() {
    // Remove active class from all related product thumbnails and their parent containers
    $('.tb-related-product').parent().removeClass('active');

    // Add active class to the clicked related product thumbnail and its parent container
    $(this).addClass('active').parent().addClass('active');

    // Get the URL of the clicked thumbnail's image
    var thumbnailSrc = $(this).attr('src');

    // Update the source attribute of the main product image
    // $('.zoom').css('background-image', 'url(' + thumbnailSrc + ')');
    $('#productPhotoImg').attr('src', thumbnailSrc);
  });
});


document.addEventListener('DOMContentLoaded', function() {
    // Add event listener for mouseenter event on .zoom element
    var zoomElement = document.querySelector('.zoom');
    if (zoomElement) {
        zoomElement.addEventListener('mouseenter', function() {
            // Get the URL of the main product image
            var img_url = document.getElementById('productPhotoImg').getAttribute('src');
            // Set background image of .zoom element to the main product image
            this.style.backgroundImage = 'url(' + img_url + ')';
        });

        // Add event listener for mouseleave event on .zoom element
        zoomElement.addEventListener('mouseleave', function() {
            // Remove background image when mouse leaves the .zoom element
            this.style.backgroundImage = 'none';
        });
    }
});



function zoom(e){
  var zoomer = e.currentTarget;
  e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
  e.offsetY ? offsetY = e.offsetY : offsetY = e.touches[0].pageY
  x = offsetX/zoomer.offsetWidth*100
  y = offsetY/zoomer.offsetHeight*100
  zoomer.style.backgroundPosition = x + '% ' + y + '%';
}



// ========================== Counter ==========================
// let isAlreadyRun = false;

//         $(window).on('scroll', function () {
//             if (isAlreadyRun) return; // Exit if already run

//             var windowHeight = $(window).height();
//             var scrollTop = $(window).scrollTop();

//             $('.counter-show').each(function () {
//                 var elementTop = $(this).offset().top;
//                 var elementHeight = $(this).outerHeight();
//                 var elementInView = scrollTop + windowHeight >= elementTop + elementHeight / 2;

//                 if (elementInView) {
//                     $(this).find('.count-number').each(function () {
//                         var targetNumber = parseInt($(this).text().replace(/[^\d]/g, ''), 10); // Extract number
//                         $(this).prop('Counter', 0).animate({
//                             Counter: targetNumber
//                         }, {
//                             duration: 1000,
//                             easing: 'swing',
//                             step: function (now) {
//                                 $(this).text(Math.ceil(now) + $(this).text().replace(/[\d]/g, '')); // Preserve text
//                             }
//                         });
//                     });
//                     isAlreadyRun = true;
//                 }
//             });
//         });

window.addEventListener("scroll", function () {
    if (window.scrollY > 50) {
        document.body.classList.add("fixed-header");
    } else {
        document.body.classList.remove("fixed-header");
    }
});

// ========================== CUSTOMERS OWL-CAROUSEL ==========================
var tb_dr_section = $(document).ready(function(){
  $('.dr-section .dr-section-wrapper').owlCarousel({
      items : 1,
      nav: true,
      dots: false,
      loop: true,
      autoplay:true,
      autoplayTimeout:5000,
      autoplayHoverPause:false,
      responsive: {
              0: {
                 items:1
              },
              576:{
                  items:1
              },
              992:{
                  items:1
              },
              1200:{
                  items:1  
              }
          }
  });
});

// ========================== Video OWL-CAROUSEL ==========================
var video_cms = $(document).ready(function () {
            // Owl Carousel Init
            $('#TB-Video-cms .video-main-wrapper').owlCarousel({
                loop: true,
                margin: 30,
                nav: true,
                dots: false,
                responsive: {
                    0: {
                        items: 1
                    },
                    481: {
                        items: 2,
                        margin:15,
                    },
                    992: {
                        items: 3
                    },
                    1200: {
                        items: 4
                    },
                }
            });
});
$(document).ready(function () {
    $('.popup-youtube').magnificPopup({
        type: 'iframe',
        iframe: {
            patterns: {
                youtube: {
                    index: 'youtube.com/', // also matches youtu.be via id function
                    id: function (url) {
                        let id = null;
                        let time = null;

                        // Match standard YouTube URL
                        let match = url.match(/[?&]v=([^?&]+)/);
                        if (match && match[1]) {
                            id = match[1];
                        } else {
                            // Match short YouTube URL
                            match = url.match(/youtu\.be\/([^?&]+)/);
                            if (match && match[1]) {
                                id = match[1];
                            } else {
                                // Match /embed/ or /v/ URLs
                                match = url.match(/\/(embed|v)\/([^?&]+)/);
                                if (match && match[2]) {
                                    id = match[2];
                                }
                            }
                        }

                        // Match time parameter (e.g. &t=666s or &t=1m30s)
                        let timeMatch = url.match(/[?&]t=([0-9hms]+)/);
                        if (timeMatch && timeMatch[1]) {
                            time = timeMatch[1];
                        }

                        // Store time in the global object for later
                        id = time ? id + '?start=' + convertTimeToSeconds(time) : id;

                        return id;
                    },
                    src: 'https://www.youtube.com/embed/%id%&autoplay=1'
                }
            }
        }
    });

    // Helper: convert YouTube time formats to seconds (e.g., 1m30s -> 90)
    function convertTimeToSeconds(timeStr) {
        if (!timeStr) return 0;
        let total = 0;
        let match;

        match = timeStr.match(/(\d+)h/);
        if (match) total += parseInt(match[1]) * 3600;

        match = timeStr.match(/(\d+)m/);
        if (match) total += parseInt(match[1]) * 60;

        match = timeStr.match(/(\d+)s/);
        if (match) total += parseInt(match[1]);

        // If timeStr is just seconds (e.g. 666), no h/m/s
        if (/^\d+$/.test(timeStr)) {
            total = parseInt(timeStr);
        }

        return total;
    }
});

document.addEventListener("DOMContentLoaded", function() {

  function hideSubDetails() {
    const subDetails = document.querySelector(".bss-sub-details");
    if (subDetails) {
      subDetails.style.display = "none";
    }
  }

  // First try
  hideSubDetails();

  // If app loads later (dynamic load)
  const observer = new MutationObserver(function() {
    hideSubDetails();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
    });

});

